// Symptom catalog per vehicle type, grouped by system.
export const SYMPTOMS = {
  auto: [
    {
      group: "Motore & Avviamento",
      items: [
        "Il motore non parte",
        "Avviamento difficile a freddo",
        "Spia motore accesa",
        "Perdita di potenza in accelerazione",
        "Minimo irregolare / si spegne",
        "Vibrazioni e scoppiettii",
      ],
    },
    {
      group: "Freni & Ruote",
      items: [
        "Freni che fischiano o cigolano",
        "Pedale del freno morbido",
        "Vibrazioni in frenata",
        "Spia ABS accesa",
        "Usura irregolare pneumatici",
      ],
    },
    {
      group: "Trasmissione & Frizione",
      items: [
        "Cambio marce difficoltoso",
        "Frizione che slitta",
        "Rumore in folle",
        "Strappi al cambio automatico",
      ],
    },
    {
      group: "Impianto Elettrico",
      items: [
        "Batteria si scarica",
        "Luci deboli o tremolanti",
        "Alzacristalli non funziona",
        "Fusibili bruciati",
      ],
    },
    {
      group: "Scarico & Fumo",
      items: [
        "Fumo nero dallo scarico",
        "Fumo bianco dallo scarico",
        "Fumo blu dallo scarico",
        "Odore di carburante",
        "Spia FAP/DPF accesa",
      ],
    },
    {
      group: "Clima & Abitacolo",
      items: [
        "Climatizzatore non raffredda",
        "Cattivo odore dalle bocchette",
        "Riscaldamento non funziona",
        "Rumore ventola abitacolo",
      ],
    },
  ],
  moto: [
    {
      group: "Motore & Avviamento",
      items: [
        "La moto non si avvia",
        "Motore che ingolfa",
        "Perdita di potenza ai medi regimi",
        "Surriscaldamento motore",
        "Minimo instabile",
        "Vuoti di carburazione",
      ],
    },
    {
      group: "Frizione & Trasmissione",
      items: [
        "Frizione a bagno d'olio che slitta",
        "Catena di trasmissione allentata/rumorosa",
        "Difficolta a innestare le marce",
        "Falsi folli",
      ],
    },
    {
      group: "Alimentazione",
      items: [
        "Carburatore/iniettore sporco",
        "Getti otturati",
        "Perdita di benzina",
        "Rubinetto benzina difettoso",
      ],
    },
    {
      group: "Ciclistica & Freni",
      items: [
        "Oscillazione del manubrio (weave/shimmy)",
        "Forcelle che perdono olio",
        "Freno anteriore poco incisivo",
        "Cuscinetti ruota rumorosi",
      ],
    },
    {
      group: "Impianto Elettrico",
      items: [
        "Batteria scarica",
        "Faro debole",
        "Frecce che non lampeggiano",
        "Regolatore di tensione guasto",
      ],
    },
  ],
};

export const ENGINE_TYPES = {
  auto: ["Benzina", "Diesel", "Ibrida", "Elettrica", "GPL/Metano"],
  moto: ["4 Tempi", "2 Tempi", "Scooter", "Elettrica"],
};
